import React,{useState} from 'react';
import Table from 'react-bootstrap/Table';
import {dateFormat} from "../../utils";
//import moment from 'moment';
import Pagination from 'react-responsive-pagination';
import moment from 'moment-timezone';
import { useNavigate } from "react-router-dom";
import DriverListModal from '../ModalContent/DriverListModal'
//import Swal from '../../../node_modules/sweetalert2/dist/sweetalert2';
import Swal from '../../messageBox/customSweetAlert';
import { DELETE_SCHEDULE } from '../../constant'; 
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../redux/loaderAction';
import axios from 'axios';

export default function UnAssignedScheduleTable({tableData,diverList,setSelectedDriverId,selectedDriverId,onSave,setSelectedScheduleId,setModalVisible,isModalVisible,setIsReload,setTableData}) {
  const dispatch = useDispatch();
  //console.log('datanew',tableData);
  //return false;
  const navigate = useNavigate();
  const handleEditClick=(id)=>{
    navigate(`/home/schedule/edit/${id}`);
   }
   
   const [error, setError] = useState(false);
   const [currentPage, setCurrentPage] = useState(1);
   const [itemsPerPage, setItemsPerPage] = useState(50);
   const totalPages = Math.ceil(tableData.length / itemsPerPage);
   const startIndex = (currentPage - 1) * itemsPerPage;
   const endIndex = startIndex + itemsPerPage;
   const paginatedData = tableData.slice(startIndex, endIndex);

   // Iterate over the data array
   const myArray = {};
   paginatedData.forEach((val) => {
    const schid = val.schedule_id;
     if (!myArray[schid]) {
        myArray[schid] = []; // Initialize as an empty array only if it doesn't exist
    }
    myArray[schid].push(val.transData);
  });
  const openModal = (scheduleId,scheduleDate) => {
   //alert(scheduleDate);
   const scheduledate = new Date(scheduleDate);
   const todayDate = new Date();
   if(scheduledate < todayDate && scheduledate.getDate() !== todayDate.getDate()){
    Swal.fire({
      title: '',
      text: "You can't assign driver to past date schedule",
      icon: 'warning',
      confirmButtonText: 'OK',
    });

   }else{
    setModalVisible(true);
    setSelectedScheduleId(scheduleId)
   }
    
};

const closeModal = () => {
    setModalVisible(false);
    setError(false); // Reset error state when modal is closed
};
const handleDeleteClick =(id)=>{
  Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this item!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(setLoading(true));
          axios.post(DELETE_SCHEDULE + '/' + `${id}`)
          .then((response)=>{
              if(response.data.status === 200){
                dispatch(setLoading(false));
                  Swal.fire({
                    title: 'Success!',
                    text: response.data.message,
                    icon: 'success',
                    confirmButtonText: 'OK',
                  });
                  //setIsReload(prev => !prev);
                  const updatedTableData = tableData.filter((item) => item.schedule_id !== id);
                      setTableData(updatedTableData);
              }else if(response.data.status === 400){
                dispatch(setLoading(false));
                Swal.fire({
                  title: '',
                  text: response.data.message,
                  icon: 'Error',
                  confirmButtonText: 'OK',
                });
              }
              //console.log(response);
          }).catch(error => {
            dispatch(setLoading(false));
              //toast.error(error, { position: "top-center" });
            })
          //alert(userId);
          
        
      }
    });
 }
 
  return (
    <><Table striped bordered hover className='tbl-require'>
      <thead>
        <tr>
          <th>#</th>
          <th>Trip Scheduled Date</th>
          <th>Schedule Type</th>
          <th>Driver</th>
          {/* <th>Vehicle</th> */}
          <th>Passenger</th>
          <th>Payer</th>
          <th>No of Leg</th>
          <th>Pickup / Drop off Details</th>
          <th>Bill Amount</th>
          <th style={{ textAlign: 'center' }}>Action</th>
        </tr>
      </thead>
      <tbody>
        {paginatedData && paginatedData.length > 0 ? (
         paginatedData.map((details, index) => {
          const legs = myArray[details.schedule_id]; 
          
          return (
            <tr key={details.schedule_id}>
              <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
              <td>{(dateFormat(details?.schedule_date) ?? '')}</td>
              <td>{details?.is_upload_schedule === '0' ? 'Manual' : 'Spreadsheet' } </td>
              <td style={{ textAlign: 'center', cursor: 'pointer' }}>
                {details.driver ? 
                (details.driver?.firstName + ' ' + details.driver?.middleName + ' ' + details.driver?.lastName) :
                 <button className='add-driver-button' onClick={()=>openModal(details.schedule_id,details?.schedule_date)}>Assign Driver</button>}
                 </td>
                 {/* <td></td> */}
              <td>{details.passenger ? 
              (details.passenger?.firstName + ' ' + 
                (details.passenger?.middleName ?? '') + ' ' + 
                (details.passenger?.lastName ?? '') + '-'+details.passenger?.passenger?.pass_pmi_no ) : ''}
                </td>
                <td>{details.passenger?.passenger?.payers?.payer_name} </td>
              <td>{details.no_of_leg}</td>
              <td>
                  {/* Loop through the legs and display the pickup/drop-off details */}
                  {legs && legs.length > 0 ? (
                    legs.map((legArray, legArrayIndex) => (
                      <div key={legArrayIndex}>
                        {legArray.map((leg, legIndex) => (
                          <div key={legIndex}>
                            <span style={{marginTop:'10px',fontWeight:'bold',textDecoration:'underline'}}>Leg {legIndex + 1}</span><br />
                            <span style={{color:'#105c64',fontStyle:'italic',fontWeight:'lighter'}}>Pickup Location:</span> 
                              {leg.pickupLocation?.pickup_location && (leg.pickupLocation.pickup_location.replace(/,,/, '') + ', ')} 
                              {leg.pickupLocation?.pickup_address && (leg.pickupLocation.pickup_address.replace(/,,/, '') + ', ')} 
                              {leg.pickupLocation?.pickup_city && (leg.pickupLocation.pickup_city.replace(/,,/, '') + ', ') }
                              {leg?.pickupLocation?.state_master_list?.pickup_state_name && (leg?.pickupLocation?.state_master_list?.pickup_state_name.replace(/,,/, '') + ', ') } 
                              {(leg?.pickupLocation?.pickup_zip || '')}<br />
                            <span style={{color:'#105c64',fontStyle:'italic',fontWeight:'lighter'}}>Pickup Time:</span> {leg.pick_up_time}<br />
                            <span style={{color:'#105c64',fontStyle:'italic',fontWeight:'lighter'}}>Drop Off Location:</span> 
                              {leg.dropoffLocation?.dropoff_location && (leg.dropoffLocation?.dropoff_location.replace(/,,/, '') + ', ') }
                              {leg.dropoffLocation?.dropoff_address && (leg.dropoffLocation?.dropoff_address.replace(/,,/, '') + ', ')}
                              {leg.dropoffLocation?.dropoff_city && (leg.dropoffLocation?.dropoff_city.replace(/,,/, '') + ', ') } 
                              {leg?.dropoffLocation?.state_master_list?.dropOff_state_name && (leg?.dropoffLocation?.state_master_list?.dropOff_state_name.replace(/,,/, '') + ', ') }
                              {leg.dropoffLocation?.dropoff_zip}
                            <br />
                            <span style={{color:'#105c64',fontStyle:'italic',fontWeight:'lighter'}}>Drop Off Time:</span> {leg.drop_off_time}<br />
                          </div>
                        ))}
                      </div>
                    ))
                  ) : (
                    <div>No legs available</div> // Handle the case where there are no legs
                  )}
              </td>
              <td>{'$' + details?.bill_amount}</td>
              {/* <td>{details.vehicleAssignedDriver?.vehicle?.vehicle_name}</td> */}
              
              
              <td style={{ textAlign: 'center', cursor: 'pointer' }}>
                <i className="pi pi-pen-to-square icon-btn-edit" onClick={() => handleEditClick(details.schedule_id)}></i>
                <i className="pi pi-trash icon-btn-delete" onClick={() => handleDeleteClick(details.schedule_id)}></i>
              </td>
            </tr>
          );
  }) ) : (
    <tr>
      <td colSpan="10" style={{ textAlign: 'center' }}>No records found</td>
    </tr>
  )}
      </tbody>
    </Table><Pagination
        current={currentPage}
        total={totalPages}
        onPageChange={(page) => setCurrentPage(page)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={50}
        containerClassName={'pagination'}
        subContainerClassName={'pages pagination'}
        activeClassName={'active'} />
        
        <DriverListModal
        visible={isModalVisible}
        onHide={closeModal}
        title="Drivers List"
        driverList={diverList}
        setSelectedDriverId={setSelectedDriverId}
        selectedDriverId={selectedDriverId}
        onSave={onSave}
        />
        </>
  )
}
